module.exports = __webpack_public_path__ + "img/vipLogo3.f878ebc6.png";